var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"label-cols":"4","label-align":"right"}},[_c('b-form-input',{attrs:{"value":_vm.textValue,"list":_vm.id,"state":_vm.valid,"disabled":_vm.disabled,"size":"sm","autocomplete":"off"},on:{"input":_vm.input}}),_c('b-form-datalist',{attrs:{"id":_vm.id,"options":_vm.mappedOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }